<template>
    <ModuloItem :dataitem="itemshome"/>
</template>

<script>
import axiosServices from "@/services/axiosServices.js"
import ModuloItem from "@/components/ModuloItem.vue"

  export default {
    name:'ListaProcesos',
    components: {
      ModuloItem,
    },
    data(){
      return{
        aProcesos:[]
      }
    },
    async mounted (){
      console.log("Antes");
      const oResponse = await axiosServices.getConfiguration("workflows", true )
      console.log("Despues");
      
      if(oResponse.nStatusCode === 200 ){
        this.aProcesos = oResponse.aData
      }

      this.$store.dispatch('setbNavegacion', false);

    },
    computed:{
      itemshome(){
        // genero el arreglo como lo requiere ModuloItem para mostrar la INFO.
        if ( this.aProcesos.length == 0 ) {
          return []
        }
        return this.aProcesos.map( proceso => ({
          Icon:'mdi-book-outline',
            Titulo: '' ,
            Descripcion: proceso.Nombre.replace(/_/g, ' '),
            Link:`/Listarprocesos/${proceso.Nombre}/${proceso.idWorkflow}`
        }))
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>